import { createCrudHooks } from '../../../shared/api/crud-hooks';
import { impostosApi } from './api';
import type { ImpostoDto, ImpostoInput, ImpostoListItem } from './types';

export const impostosHooks = createCrudHooks<ImpostoListItem, ImpostoDto, ImpostoInput>({
  queryKey: ['impostos'],
  api: impostosApi,
});
